<script lang="ts">
    import Modal from 'src/components/cabinet/#common/modal/Modal.svelte.ts'
    import Time from 'svelte-time'
    import {Table} from 'sveltestrap'
    import Pagination from 'src/components/#common/pagination/Pagination.svelte'
    import {
        getAllConfirmationActions,
        deleteAction,
        addSolutionAdmin,
        getNotConfirmedActionsCount,
        addSolutionAdminForMany
    } from 'src/components/cabinet/#services/confirmationActions'
    import {getSettingOption} from 'src/components/cabinet/#services/settingsOption'
    import {doShow as showAlert} from 'src/components/#common/alert/store'
    import {myRole} from 'src/components/#common/myRole'
    import {userProfile} from 'src/services/auth'
    import {delay} from 'src/global/delay'
    import PerPage from 'src/components/#common/pagination/PerPage.svelte'
    import {roundNumber} from 'src/global/roundNumber'

    let currentPage = 0
    let perPage = 25
    let maxButtons = 5

    let action
    let loading = false
    let showDeleteActionModal = false
    let showConfirmModal = false
    let idForAction
    let selectedItems = []
    let selectedAll = false

    getAllConfirmationActions.reset()
    getAllConfirmationActions.send({data:{
        page: currentPage + 1,
        perPage,
        tab: 'balance'
    }})

    function confirmationCount() {
        getSettingOption.request({ data: { clientKey: "confirmations.confirmationCount" } })
    }

    $:currentPage,perPage,update(),confirmationCount()

    function update() {
        getAllConfirmationActions.reset()
        getAllConfirmationActions.send({data:{
                page: currentPage + 1,
                perPage,
                tab: 'balance'
            }})

        getNotConfirmedActionsCount.send()
        selectedAll = false
        selectedItems = []
    }

    async function addSolutionAdminHandler() {
        try {
            loading = true

            await addSolutionAdmin.request({ data: {
                    id: idForAction,
                    isConfirmed: action
                }})
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            await delay(500)
            loading = false
            showConfirmModal = false
            update()
        }
    }

    async function deleteActionHandler() {
        try {
            loading = true

            await deleteAction.request({ data: {
                    id: idForAction
                }})

            showAlert.set({
                status: 'success',
                text: 'Action canceled successfully'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            loading = false
            showDeleteActionModal = false
            update()
        }
    }

    function toggleItem(id) {
        selectedAll = false
        if (selectedItems.includes(id)) {
            let index = selectedItems.indexOf(id)
            if (index !== -1) selectedItems.splice(index, 1)
            selectedItems = [...selectedItems]
        } else {
            selectedItems = [...selectedItems, id]
        }
    }

    function toggleAll() {
        if (!selectedAll) {
            selectedItems = []
            $getAllConfirmationActions.value.data.map(elem => {
                if (elem.isSuccess === null && !elem.history?.some(e => e.userId === $userProfile?.userId)) {
                    selectedItems = [...selectedItems, elem.id]
                }
            })
            selectedItems = selectedItems
            if (selectedItems.length) {
                selectedAll = true
            }
        } else {
            selectedAll = false
            selectedItems = []
        }
    }

    async function addSolutionAdminForManyHandler(action) {
        try {
            loading = true

            await addSolutionAdminForMany.request({ data: {
                    ids: selectedItems,
                    isConfirmed: action
                }})
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            loading = false
            showConfirmModal = false
            update()
        }
    }
</script>

<div class="actions-list">
    {#if $getAllConfirmationActions.hasValue}
        <PerPage
            bind:perPage={perPage}
            disabled={$getAllConfirmationActions.loading || $getAllConfirmationActions.loading}
            totalCount={$getAllConfirmationActions.value.totalCount}
        />
    {/if}
    {#if $myRole?.value?.methods.includes('addSolutionAdmin')}
        <div class="d-flex mb-3">
            <button class="btn btn-primary mr-2" class:loading={loading} on:click={toggleAll} disabled={loading}>{#if !selectedAll}Select all{:else}Deselect all{/if}</button>
            <button class="btn btn-success mr-2" class:loading={loading} on:click={() => addSolutionAdminForManyHandler(true)} disabled={loading || !selectedItems.length || !$getAllConfirmationActions.hasValue}>Approve</button>
            <button class="btn btn-danger" class:loading={loading} on:click={() => addSolutionAdminForManyHandler(false)} disabled={loading || !selectedItems.length || !$getAllConfirmationActions.hasValue}>Deny</button>
        </div>
    {/if}
    <Table bordered striped responsive>
        <thead>
        <tr>
            {#if $myRole?.value?.methods.includes('addSolutionAdmin')}
                <td class="text-center col-auto">...</td>
            {/if}
            <td class="text-center">Status</td>
            <td class="text-center">Amount</td>
            <td class="text-center">User</td>
            <td class="text-center">Comment</td>
            <td class="text-center">Date</td>
            <td class="text-center">Actions</td>
        </tr>
        </thead>
        <tbody>
        {#if $getAllConfirmationActions.loading}
            {#each {length: perPage} as item}
                <tr>
                    {#if $myRole?.value?.methods.includes('addSolutionAdmin')}
                        <td><span class="loading transaction-loading col-auto"></span></td>
                    {/if}
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                </tr>
            {/each}
        {:else if $getAllConfirmationActions.error || !$getAllConfirmationActions.hasValue}
            <tr>
                {#if $myRole?.value?.methods.includes('addSolutionAdmin')}
                    <td class="text-center" colspan="7">Something went wrong. Try refreshing the page.</td>
                {:else}
                    <td class="text-center" colspan="6">Something went wrong. Try refreshing the page.</td>
                {/if}
            </tr>
        {:else}
            {#each $getAllConfirmationActions.value.data as row}
                <tr class="table-card" class:suspicious={row.suspicious}>
                    {#if $myRole?.value?.methods.includes('addSolutionAdmin')}
                        <td class="text-center col-auto">
                            {#if row.isSuccess === null && !row.history?.some(e => e.userId === $userProfile?.userId)}
                                <label class="checkbox">
                                    <input type="checkbox" class="form-check-input" checked={selectedItems.includes(row.id)} on:change={() => toggleItem(row.id)}>
                                </label>
                            {/if}
                        </td>
                    {/if}
                    <td class="text-center">
                        {#if row.isSuccess === true }
                            <span class="status-success">Success</span>
                        {:else if row.isSuccess === false}
                            <span class="status-cancelled">Cancelled</span>
                        {:else}
                            <span class="status-pending">Pending
                            ({#if row.history}{@html Object.keys(row.history).length}{:else}0{/if}/{$getSettingOption.value?.value})
                            </span>
                        {/if}
                    </td>
                    <td class="text-center">{#if row.infoMethod.method === 'balance_adminIncreaseBalance'}+{:else if row.infoMethod.method === 'balance_adminDecreaseBalance'}-{/if}{roundNumber(+row.infoMethod.params.amount)} {row.infoMethod.params.currency} (<a href="/profile/{row.userId}" target="_blank" rel="noreferrer">who</a>)</td>
                    <td class="text-center user-link"><a href="/profile/{row.infoMethod.params.userId}" target="_blank" rel="noreferrer">{row.email}</a></td>
                    <td class="comment">{#if row.infoMethod.params?.extraDetail?.comment}{row.infoMethod.params.extraDetail.comment}{/if}</td>
                    <td class="text-center nobr action-date">{new Date(row.createdAt).toLocaleString()}</td>
                    <td class="text-center">
                        {#if row.isSuccess == null && $userProfile?.userId === row.userId}
                            <button class="btn btn-primary" on:click={() => {idForAction = row.id; showDeleteActionModal = true }}>Cancel</button>
                        {:else if row.isSuccess == null && $myRole?.value?.methods.includes('addSolutionAdmin') && !row.history?.some(e => e.userId === $userProfile?.userId)}
                            <button class="btn btn-success" on:click={()=>{idForAction = row.id; action = true; showConfirmModal = true}}>Yes</button>
                            <button class="btn btn-danger" on:click={()=>{idForAction = row.id; action = false; showConfirmModal = true}}>No</button>
                        {/if}
                    </td>
                </tr>
            {/each}
        {/if}
        </tbody>
        <Modal bind:visible={showConfirmModal}>
            <svelte:fragment slot="content">
                <div class="modal-custom__title">Action confirmation</div>
                <div class="modal-custom__text">Are you sure you want to confirm <strong>[{#if action}Yes{:else}No{/if}]</strong> action?</div>
                <div class="modal-custom__footer">
                    <button class="btn btn-cancel" on:click={() => { showConfirmModal = false }}>Close</button>
                    <button class="btn btn-primary" class:loading={loading} on:click={addSolutionAdminHandler} disabled={loading}>Confirm</button>
                </div>
            </svelte:fragment>
        </Modal>
        <Modal bind:visible={showDeleteActionModal}>
            <svelte:fragment slot="content">
                <div class="modal-custom__title">Cancel action</div>
                <div class="modal-custom__text">Are you sure you want to undo your action?</div>
                <div class="modal-custom__footer">
                    <button class="btn btn-cancel" on:click={() => { showDeleteActionModal = false }}>Close</button>
                    <button class="btn btn-primary" class:loading={loading} on:click={deleteActionHandler} disabled={loading}>Confirm</button>
                </div>
            </svelte:fragment>
        </Modal>
    </Table>
    {#if $myRole?.value?.methods.includes('addSolutionAdmin')}
        <div class="d-flex mb-3">
            <button class="btn btn-primary mr-2" class:loading={loading} on:click={toggleAll} disabled={loading}>{#if !selectedAll}Select all{:else}Deselect all{/if}</button>
            <button class="btn btn-success mr-2" class:loading={loading} on:click={() => addSolutionAdminForManyHandler(true)} disabled={loading || !selectedItems.length || !$getAllConfirmationActions.hasValue}>Approve</button>
            <button class="btn btn-danger" class:loading={loading} on:click={() => addSolutionAdminForManyHandler(false)} disabled={loading || !selectedItems.length || !$getAllConfirmationActions.hasValue}>Deny</button>
        </div>
    {/if}
    {#if $getAllConfirmationActions.hasValue}
        <Pagination
            bind:currentPage={currentPage}
            totalCount={$getAllConfirmationActions.value.totalCount}
            {perPage}
            {maxButtons}
            disabled={$getAllConfirmationActions.loading || $getAllConfirmationActions.loading}
        />
    {/if}
</div>

<style>
    .transaction-loading {
        height: 24px;
        width: 100%;
        display: block;
    }

    .comment {
        width: 300px;
    }

    .mr-2 {
        margin-right: 10px;
    }

    .buttons .btn {
        margin-left: 5px;
    }

    .btn.btn-secondary {
        padding: 10px 20px;
        font-size: 14px;
        line-height: normal;
        border: 0;
        box-shadow: none;
    }

    td .btn {
        padding: 6px 20px !important;
        margin: -6px 0 !important;
    }

    td {
        vertical-align: middle;
        min-width: 150px;
    }

    .btn.active {
        background: #FF5D1C;
    }

    .status-pending {
        color: #ff9800;
    }

    .status-cancelled {
        color: #f44336;
    }

    .status-success {
        color: #4caf50;
    }

    input[type="date"] {
        width: auto;
        display: inline-block;
        vertical-align: top;
    }

    .nobr {
        white-space: nowrap;
    }

    .checkbox {
        padding: 0 20px;
        font-size: 20px;
    }

    .suspicious .checkbox {
        padding: 20px 20px 0;
    }

    .checkbox input {
        font-size: 20px;
    }

    .col-auto {
        width: 80px;
        min-width: 70px;
        margin: 0 auto;
    }

    .table-card.suspicious {
        background: #ffe2e0;
        position: relative;
    }

    .table-card.suspicious td:first-child:before {
        content: "Suspicious";
        position: absolute;
        font-size: 11px;
        background: #f44336;
        border-radius: 3px;
        padding: 1px 5px;
        color: white;
        top: 5px;
        left: 5px;
    }

    @media(max-width: 991px) {
        thead {
            display: none;
        }

        td {
            display: block;
        }

        td:empty {
            display: none !important;
        }

        .table-card {
            text-align: center;
            margin-bottom: 12px;
            display: block;
        }

        .table-card td:last-child {
            padding-bottom: 20px;
        }

        .user-link {
            padding: 0;
        }

        .action-date {
            font-size: 14px;
            color: #787878;
        }

        .col-auto {
            width: 100%;
            min-width: 100%;
            margin: 0 auto;
            position: relative;
        }

        .checkbox {
            padding: 12px;
            font-size: 18px;
            position: absolute;
            left: 0;
            top: 15px;
        }
    }
</style>
